/**
 * @generated SignedSource<<3c1dfe16be7eff066f3c87410a370cb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateLabelCategoryInput = {
  name?: string | null;
  allowOnPeople?: boolean | null;
  allowOnProjects?: boolean | null;
  allowOnTasks?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createLabelCategoryMutation$variables = {
  input: CreateLabelCategoryInput;
};
export type createLabelCategoryMutation$data = {
  readonly createLabelCategory: {
    readonly labelCategory: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly allowOnTasks: boolean | null;
        readonly allowOnProjects: boolean | null;
        readonly allowOnPeople: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type createLabelCategoryMutation = {
  variables: createLabelCategoryMutation$variables;
  response: createLabelCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateLabelCategoryPayload",
    "kind": "LinkedField",
    "name": "createLabelCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LabelCategoryTypeEdge",
        "kind": "LinkedField",
        "name": "labelCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelCategory",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowOnTasks",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowOnProjects",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowOnPeople",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createLabelCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createLabelCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "20611fd232d330932023983b2418eb7e",
    "id": null,
    "metadata": {},
    "name": "createLabelCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation createLabelCategoryMutation(\n  $input: CreateLabelCategoryInput!\n) {\n  createLabelCategory(input: $input) {\n    labelCategory {\n      node {\n        id\n        name\n        allowOnTasks\n        allowOnProjects\n        allowOnPeople\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7566b2771c833fea77ab6ff016f6cb13";

export default node;
